module.exports = __webpack_public_path__ + "img/type-select-active.36904e8d.svg";